export const PRICE_TYPE_COOKIE_NAME = 'priceType';
export const PRICE_TYPE_EXPLANATION_COOKIE_NAME = 'priceTypeExplanation';
